export default __webpack_public_path__ + "static/Group 634-05557e00ce3ce50a3d684af2137073d7.png";